export default {
  emailsPerTable: 20,
  assignLimit: 2,
  minEmails: 3
};
